import type { CompetitorCreativeCardModel } from "./drilldown-card.types"
import { formatYmd } from "./drilldown-row"

export interface DrilldownCreativeDrawerModel {
  id: string
  hash: string
  brandName: string
  competitor: string
  logoUrl: string | null
  isVideo: boolean
  isCarousel: boolean
  thumbnailUrl: string
  assetUrl: string
  carouselSlides: CompetitorCreativeCardModel["carouselSlides"]
  adLibUrl: string
  launchDate: string
  /** Drives the launch-date status dot — green when active, red when inactive. */
  launchDateStatus: "active" | "inactive" | null
  creativeLifespanDays: number
  daysPerAsset: number
  assets: number
  duplications: number
  format: "video" | "image" | "carousel"
}

function resolveFormat(creative: CompetitorCreativeCardModel): DrilldownCreativeDrawerModel["format"] {
  if (creative.isCarousel) return "carousel"
  if (creative.isVideo) return "video"
  return "image"
}

function resolveLaunchDateStatus(effectiveStatus: string): "active" | "inactive" | null {
  if (effectiveStatus === "active") return "active"
  if (effectiveStatus === "inactive") return "inactive"
  return null
}

export function mapCompetitorToDrawerModel(
  creative: CompetitorCreativeCardModel,
): DrilldownCreativeDrawerModel {
  return {
    id: creative.id,
    hash: creative.hash,
    brandName: creative.brandName,
    competitor: creative.competitor,
    logoUrl: creative.logoUrl,
    isVideo: creative.isVideo,
    isCarousel: creative.isCarousel,
    thumbnailUrl: creative.thumbnailUrl,
    assetUrl: creative.assetUrl,
    carouselSlides: creative.carouselSlides,
    adLibUrl: creative.adLibUrl,
    launchDate: formatYmd(creative.minDate),
    launchDateStatus: resolveLaunchDateStatus(creative.effectiveStatus),
    creativeLifespanDays: creative.days,
    daysPerAsset: creative.daysPerAsset,
    assets: creative.assets,
    duplications: creative.dupCount ?? 0,
    format: resolveFormat(creative),
  }
}

export const DRAWER_NARRATIVE_FIELDS = [
  "topics",
  "presenterAge",
  "targetAudience",
  "angle",
  "painPoint",
  "motivation",
  "persona",
  "concepts",
  "sequence",
  "verbalHooks",
  "textOverlay",
] as const

export type DrawerNarrativeField = (typeof DRAWER_NARRATIVE_FIELDS)[number]
